import { CellularProviderType } from "@app/shared/databases/cellular.database.service";

export enum CellularProviderStatuses {
    PreActive = "pre-active",
    Active = "active",
    Deactive = "deactive",
    Suspended = "suspend",
    PendingRelease = "pending resume",
    PendingMdnChange = "pending MDN change",
    PendingPrlUpdate = "pending PRL update",
    PendingPreactive = "pending preactive",
    PendingActivation = "pending activation",
    PendingDeactivation = "pending deactivation",
    PendingSuspension = "pending suspension",
    PendingServicePlanChange = "pending service plan change",
    PendingEsnMeidChange = "pending ESN/MEID change",
    PendingAccountUpdate = "pending account update",
    Unknown = "unknown",
    // AT&T statuses
    Activated = "ACTIVATED", // Normalized to active by CellLink
    ActivationReady = "ACTIVATION_READY",
    Deactivated = "DEACTIVATED", // Normalized to deactive by CellLink
    Inventory = "INVENTORY",
    Purged = "PURGED",
    Replace = "REPLACE",
    Retired = "RETIRED",
    TestReady = "TEST_READY",
    // Normalized status
    Inactive = "inactive",
}

export interface CellularProvider {
    carrierName: APNType;
    state: CellularProviderStatuses;
}

export interface APNType {
    type: CellularProviderType;
    label?: "Verizon" | "AT&T" | "bmobile" | "None";
}

export const APN_LIST: APNType[] = [
    {
        type: CellularProviderType.VERIZON,
        label: "Verizon",
    },
    {
        type: CellularProviderType.ATT,
        label: "AT&T",
    },
    {
        type: CellularProviderType.BMOBILE,
        label: "bmobile",
    },
    {
        type: CellularProviderType.NONE,
        label: "None",
    },
];

export interface CellularDevice {
    imei: string;
    iccid: string;
    accountId: string;
    ratePlan: string;
    status: CellularProviderStatuses;
    dateActivated: string;
    dateUpdated: string;
    dateShipped: string;
    provider?: CellularProviderType;
    meid?: string;
}

export class CellularDeviceHelper {
    static getDefault(): CellularDevice {
        return {
            imei: "",
            iccid: "",
            accountId: "",
            ratePlan: "",
            status: CellularProviderStatuses.Unknown,
            dateActivated: "",
            dateUpdated: "",
            dateShipped: "",
            provider: null,
        };
    }

    static fromDbObject(dbObject: Partial<CellularDevice>): CellularDevice {
        return {
            imei: dbObject.imei || null,
            iccid: dbObject.iccid || null,
            accountId: dbObject.accountId || null,
            ratePlan: dbObject.ratePlan || null,
            status: dbObject.status || null,
            dateActivated: dbObject.dateActivated || null,
            dateUpdated: dbObject.dateUpdated || null,
            dateShipped: dbObject.dateShipped || null,
            provider: dbObject.provider || null,
            meid: dbObject.meid || null,
        };
    }
}
